import { ChevronBackward, Close } from '@project-lary/react-material-symbols';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { SidebarHeader } from 'gcs-common/design-system/ui/sidebar';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';

interface ProfileHeaderProos {
  title: string;
  onBack: VoidFunction;
}

const ProfileHeader = (props: ProfileHeaderProos) => {
  const { title, onBack } = props;
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
  };

  return (
    <SidebarHeader>
      <div className={styles.headerMemberButtons}>
        <button>
          <IconButton
            Icon={ChevronBackward}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
            onClick={onBack}
          />
        </button>
      </div>

      <div className={styles.headerMemberDetails}>{title}</div>
      <div className={styles.headerMemberButtons}>
        <button>
          <IconButton
            Icon={Close}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
            onClick={onClose}
          />
        </button>
      </div>
    </SidebarHeader>
  );
};

export default ProfileHeader;
